import AppsRegistry from '../services/apps-registry';
export { IAvatarOption, TitleOption, } from '../services/apps-registry';
var _appRegistry = new AppsRegistry();
export var registerApp = function (_a) {
    var appName = _a.appName, component = _a.component, options = _a.options;
    return _appRegistry.registerApp({ appName: appName, component: component, options: options });
};
export var removeApp = function (appName) {
    return _appRegistry.removeApp(appName);
};
export var isAppRegistered = function (appName) {
    return _appRegistry.isAppRegistered(appName);
};
export var getComponentByApp = function (appName) {
    return _appRegistry.getComponentByApp(appName);
};
export var getConfigByApp = function (appName) {
    return _appRegistry.getConfigByApp(appName);
};
//# sourceMappingURL=apps-registry-api.js.map